import { useState } from 'react';
import PanelLayout from '../components/PanelLayout';

export default function HesapPage() {
  const [showDelete, setShowDelete] = useState(false);
  const [showFreeze, setShowFreeze] = useState(false);
  const [showPhoneChange, setShowPhoneChange] = useState(false);
  const [showKVKK, setShowKVKK] = useState(false);
  const [phoneForm, setPhoneForm] = useState({ phone: '', otp: '' });
  const [otpSent, setOtpSent] = useState(false);
  const [phoneStep, setPhoneStep] = useState(1);
  const [kvkkConsent, setKvkkConsent] = useState(true);
  const [whatsappConsent, setWhatsappConsent] = useState(true);

  const handlePhoneChange = () => {
    if (phoneStep === 1 && phoneForm.phone.length >= 10) {
      setOtpSent(true);
      setPhoneStep(2);
    } else if (phoneStep === 2 && phoneForm.otp.length === 6) {
      setShowPhoneChange(false);
      setPhoneStep(1);
      setPhoneForm({ phone: '', otp: '' });
      setOtpSent(false);
      alert('Telefon numaranız değiştirildi. Admin onayı bekleniyor.');
    }
  };

  return (
    <PanelLayout>
      <div className="max-w-2xl mx-auto">
        <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500 mb-2">Hesap Ayarları</h1>
        <p className="text-sm text-gray-500 mb-6">
          Hesap bilgilerinizi, izinlerinizi ve tercihlerinizi yönetin.
        </p>

        <div className="space-y-4">
          {/* Phone Change */}
          <div className="bg-white rounded-xl border border-gray-100">
            <div className="p-5 flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-deep-navy-500">Telefon Numarası</p>
                <p className="text-xs text-gray-500 mt-0.5">555 *** ** 42</p>
              </div>
              <button
                onClick={() => setShowPhoneChange(!showPhoneChange)}
                className="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-600 text-xs font-medium hover:bg-gray-200 transition-colors cursor-pointer"
              >
                Değiştir
              </button>
            </div>
            {showPhoneChange && (
              <div className="px-5 pb-5 border-t border-gray-50 pt-4">
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4 flex items-start gap-2">
                  <span className="w-4 h-4 flex items-center justify-center text-amber-600 shrink-0 mt-0.5">
                    <i className="ri-alert-line text-xs" />
                  </span>
                  <p className="text-xs text-amber-700">
                    Telefon değişikliği destek talebi + yeni numara doğrulaması + admin onayı gerektirir.
                  </p>
                </div>

                {phoneStep === 1 && (
                  <div className="space-y-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-500 mb-1">Yeni Telefon Numarası</label>
                      <input
                        type="tel"
                        value={phoneForm.phone}
                        onChange={(e) => setPhoneForm({ ...phoneForm, phone: e.target.value })}
                        className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm text-deep-navy-500 focus:outline-none focus:border-dark-teal-500"
                        placeholder="5XX XXX XX XX"
                      />
                    </div>
                    <button
                      onClick={handlePhoneChange}
                      className="px-4 py-2 rounded-lg bg-dark-teal-500 text-white text-xs font-semibold hover:bg-dark-teal-600 transition-colors cursor-pointer"
                    >
                      Doğrulama Kodu Gönder
                    </button>
                  </div>
                )}

                {phoneStep === 2 && (
                  <div className="space-y-3">
                    <p className="text-xs text-gray-500">
                      {phoneForm.phone} numarasına doğrulama kodu gönderildi.
                    </p>
                    <div>
                      <label className="block text-xs font-medium text-gray-500 mb-1">6 Haneli Kod</label>
                      <input
                        type="text"
                        maxLength={6}
                        value={phoneForm.otp}
                        onChange={(e) => setPhoneForm({ ...phoneForm, otp: e.target.value.replace(/\D/g, '').slice(0, 6) })}
                        className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm text-deep-navy-500 focus:outline-none focus:border-dark-teal-500 tracking-[0.5em] text-center"
                        placeholder="______"
                      />
                    </div>
                    <div className="flex gap-2">
                      <button
                        onClick={handlePhoneChange}
                        className="px-4 py-2 rounded-lg bg-dark-teal-500 text-white text-xs font-semibold hover:bg-dark-teal-600 transition-colors cursor-pointer"
                      >
                        Onayla ve Değiştir
                      </button>
                      <button
                        onClick={() => { setPhoneStep(1); setOtpSent(false); setPhoneForm({ ...phoneForm, otp: '' }); }}
                        className="px-4 py-2 rounded-lg bg-gray-100 text-gray-600 text-xs font-medium cursor-pointer"
                      >
                        Tekrar Gönder
                      </button>
                    </div>
                  </div>
                )}

                <button
                  onClick={() => { setShowPhoneChange(false); setPhoneStep(1); setPhoneForm({ phone: '', otp: '' }); }}
                  className="mt-3 text-xs text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  İptal
                </button>
              </div>
            )}
          </div>

          {/* Consents */}
          <div className="bg-white rounded-xl border border-gray-100 divide-y divide-gray-50">
            <div className="p-5 flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-deep-navy-500">KVKK Onayı</p>
                <p className="text-xs text-gray-500 mt-0.5">Kişisel verilerin işlenmesine izin verdiniz.</p>
              </div>
              <button
                onClick={() => setShowKVKK(!showKVKK)}
                className="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-600 text-xs font-medium hover:bg-gray-200 transition-colors cursor-pointer"
              >
                Yönet
              </button>
            </div>
            {showKVKK && (
              <div className="px-5 pb-5 pt-4">
                <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
                  <p className="text-xs text-red-600">
                    KVKK iznini geri çekerseniz hesabınız dondurulur ve tüm eşleşme işlemleri durdurulur.
                  </p>
                </div>
                <div className="flex items-center justify-between py-2">
                  <span className="text-sm text-deep-navy-500">KVKK Onayı Aktif</span>
                  <button
                    onClick={() => setKvkkConsent(!kvkkConsent)}
                    className={`w-11 h-6 rounded-full transition-colors relative ${
                      kvkkConsent ? 'bg-dark-teal-500' : 'bg-gray-200'
                    }`}
                  >
                    <span
                      className="absolute top-0.5 w-5 h-5 rounded-full bg-white shadow-sm transition-transform"
                      style={{ left: kvkkConsent ? '22px' : '2px' }}
                    />
                  </button>
                </div>
                <button
                  onClick={() => setShowKVKK(false)}
                  className="mt-3 text-xs text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  Kapat
                </button>
              </div>
            )}
            <div className="p-5 flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-deep-navy-500">WhatsApp Bildirimleri</p>
                <p className="text-xs text-gray-500 mt-0.5">WhatsApp üzerinden bildirim alıyorsunuz.</p>
              </div>
              <button
                onClick={() => setWhatsappConsent(!whatsappConsent)}
                className={`w-11 h-6 rounded-full transition-colors relative ${
                  whatsappConsent ? 'bg-dark-teal-500' : 'bg-gray-200'
                }`}
              >
                <span
                  className="absolute top-0.5 w-5 h-5 rounded-full bg-white shadow-sm transition-transform"
                  style={{ left: whatsappConsent ? '22px' : '2px' }}
                />
              </button>
            </div>
          </div>

          {/* Account Freeze */}
          <div className="bg-white rounded-xl border border-gray-100">
            <div className="p-5">
              <button
                onClick={() => setShowFreeze(!showFreeze)}
                className="text-sm font-medium text-amber-600 hover:text-amber-700 transition-colors cursor-pointer"
              >
                Hesabımı Dondur
              </button>
              <p className="text-xs text-gray-500 mt-1">
                Hesabınızı geçici olarak dondurun. Profil ve verileriniz korunur, eşleşme durdurulur.
              </p>
              {showFreeze && (
                <div className="mt-3 p-3 bg-amber-50 rounded-lg">
                  <p className="text-xs text-amber-700 mb-2">
                    Hesabınızı dondurmak istediğinizden emin misiniz? Görüşmeleriniz beklemede kalacak, yeni talepler alınmayacaktır.
                  </p>
                  <div className="flex gap-2">
                    <button className="px-3 py-1.5 rounded-lg bg-amber-500 text-white text-xs font-medium cursor-pointer">
                      Evet, Dondur
                    </button>
                    <button
                      onClick={() => setShowFreeze(false)}
                      className="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-600 text-xs font-medium cursor-pointer"
                    >
                      İptal
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Account Delete */}
          <div className="bg-white rounded-xl border border-gray-100">
            <div className="p-5">
              <button
                onClick={() => setShowDelete(!showDelete)}
                className="text-sm font-medium text-red-500 hover:text-red-600 transition-colors cursor-pointer"
              >
                Hesabımı Sil
              </button>
              <p className="text-xs text-gray-500 mt-1">
                Hesabınızı kalıcı olarak silin. Bu işlem geri alınamaz.
              </p>
              {showDelete && (
                <div className="mt-3 p-4 bg-red-50 border border-red-100 rounded-lg">
                  <p className="text-xs text-red-600 mb-2">
                    Hesabınızı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
                  </p>
                  <p className="text-xs text-gray-500 mb-3 bg-white p-2 rounded">
                    <strong>Not:</strong> Spa CRM'deki geçmiş kayıtlar anonimleştirilerek saklanabilir.
                  </p>
                  <div className="flex gap-2">
                    <button className="px-3 py-1.5 rounded-lg bg-red-500 text-white text-xs font-medium cursor-pointer">
                      Evet, Kalıcı Olarak Sil
                    </button>
                    <button
                      onClick={() => setShowDelete(false)}
                      className="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-600 text-xs font-medium cursor-pointer"
                    >
                      İptal
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </PanelLayout>
  );
}